import ICustomForm from "../../ICustomForm";
import UX from "../UX";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import {TextboxItem} from "../../../model/items/textbox";
import UXTreeComponent, {Tree} from "./UXTreeComponent";
import moment from "moment";
import {CheckboxItem} from "../../../model/items/checkbox";
import CheckboxCell from "../../shared/components/FormCell/CheckboxCell";

export default class UXTree extends UX implements ICustomForm {

    private readonly validationBox: TextboxItem;
    private readonly stopwatch: TextboxItem;
    private readonly answerBoxes: TextboxItem[] = [];
    private readonly globalUnknown: CheckboxCell|null = null;
    private readonly treeComponent: UXTreeComponent;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const layout = settings.form.grid.layout;

        this.validationBox = <TextboxItem>layout[0][1].cellItems[0];
        this.stopwatch = <TextboxItem>layout[1][1].cellItems[0];

        const checkbox = <CheckboxItem>layout[2][1].cellItems[0];
        if (checkbox) {
            this.globalUnknown = new CheckboxCell(
                checkbox.cell,
                (cellItem, value) => {
                    this.onSetValue(cellItem, value);
                    if (value && cellItem.globalUnknown) {
                        this.treeComponent.reset();
                    }
                },
            );
        }

        layout[3].forEach(c => this.answerBoxes.push(<TextboxItem>c.cellItems[0]));

        this.treeComponent = new UXTreeComponent(
            layout.slice(4),
            node => {
                let n: Tree|null = node;
                for (let i = this.answerBoxes.length-1; i>=0; i--) {
                    const answerBox = this.answerBoxes[i];
                    if (n && i > node.depth) {
                        answerBox.reset();
                    } else {
                        answerBox.set(n?.label || '');
                        n = n?.parent || null;
                    }
                }

                this.log(node);
                this.validationBox.set(node.subtree.length === 0 || '');
            }
        );

        const path = this.answerBoxes.map(b => b.getVariable()).filter(l => l);
        this.treeComponent.open(path);
        this.treeComponent.select(path);

        if (!this.stopwatch.getVariable()) {
            this.log(/* LOADED */);
        }
    }

    private log(node?: Tree): void {
        let message = moment().format('YYYY-MM-DD HH:mm:ss.SSS') +' ';
        if (node) {
            message += (node.open ? 'OPEN' : 'CLOSE') +': '+ node.label;
        } else {
            message += 'LOADED';
        }
        this.stopwatch?.set(
            (this.stopwatch.getVariable() || '') + message + '\n'
        );
    }

    public view(): Vnode {
        return this.viewLayout([
            m(this.treeComponent),
            this.globalUnknown ? m(this.globalUnknown) : null,
        ])
    }

}
